import React from "react";
import { TableBody as MUITableBody, TableRow, TableCell } from "@material-ui/core";

function TableBody({instance}) {
    const {
        getTableBodyProps,
        page,
        prepareRow,
    } = instance;

    return(
        <MUITableBody {...getTableBodyProps()}>
            {page.map(row => {
                prepareRow(row)
                return (
                    <TableRow {...row.getRowProps()}>
                        {row.cells.map(cell => {
                            return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>
                        })}
                    </TableRow>
                )
            })}
        </MUITableBody>
    );
}

export default TableBody;
